module.exports = __webpack_public_path__ + "img/kyzq.8fbfbe1a.png";